import { Controller } from "react-hook-form";
import RichTextEditor from "@/components/editor/RichTextEditor";
import type { ActivityTabProps } from "./types";

export default function DescriptionTab({ form }: ActivityTabProps) {
  const { control } = form;

  return (
    <div className="card">
      <h2 className="mb-4 text-lg font-semibold text-gray-900 dark:text-white">Full description</h2>
      <Controller
        name="description"
        control={control}
        render={({ field }) => (
          <RichTextEditor
            content={field.value || ""}
            onChange={field.onChange}
            placeholder="Detailed activity description..."
          />
        )}
      />
    </div>
  );
}
